export default "__VITE_ASSET__w0lLtZca__"